import { render, staticRenderFns } from "./LabBuffersA.vue?vue&type=template&id=d0ac78f8&"
import script from "./LabBuffersA.vue?vue&type=script&lang=ts&"
export * from "./LabBuffersA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports